import { SvgIcon, SxProps, Theme } from "@mui/material";
import { ReactElement } from "react";

export default function AiCoachingNotificationSvg({
    sx,
}: {
    sx?: SxProps<Theme>;
}): ReactElement {
    return (
        <SvgIcon
            viewBox="0 0 32 32"
            sx={{ ...sx, width: 32, height: 32, fill: "none" }}
        >
            <circle
                cx="16"
                cy="16"
                r="16"
                fill="url(#paint0_linear_11575_8504)"
                fillOpacity="0.1"
            />
            <path
                d="M16.7545 19.8538C17.2895 19.5985 17.8276 19.407 18.3687 19.2793C18.9097 19.1516 19.466 19.0878 20.0375 19.0878C20.4752 19.0878 20.9038 19.1243 21.3233 19.1972C21.7428 19.2702 22.1653 19.3796 22.5909 19.5255V12.303C22.1897 12.1328 21.7732 12.0051 21.3416 11.92C20.9099 11.8349 20.4752 11.7923 20.0375 11.7923C19.466 11.7923 18.9006 11.8653 18.3413 12.0112C17.782 12.1571 17.2531 12.376 16.7545 12.6678V19.8538ZM16.025 22.006C15.4414 21.5439 14.8091 21.1852 14.1282 20.9299C13.4473 20.6746 12.742 20.5469 12.0125 20.5469C11.5018 20.5469 11.0003 20.6138 10.5078 20.7475C10.0154 20.8813 9.5442 21.0697 9.09432 21.3129C8.83898 21.4467 8.59276 21.4406 8.35565 21.2947C8.11855 21.1488 8 20.936 8 20.6563V11.8653C8 11.7315 8.03344 11.6039 8.10031 11.4823C8.16719 11.3607 8.2675 11.2695 8.40125 11.2087C8.97273 10.929 9.5594 10.7132 10.1613 10.5612C10.7632 10.4092 11.3802 10.3333 12.0125 10.3333C12.7177 10.3333 13.4078 10.4244 14.0826 10.6068C14.7574 10.7892 15.4049 11.0628 16.025 11.4276C16.6451 11.0628 17.2926 10.7892 17.9674 10.6068C18.6422 10.4244 19.3323 10.3333 20.0375 10.3333C20.6698 10.3333 21.2868 10.4092 21.8887 10.5612C22.4906 10.7132 23.0773 10.929 23.6487 11.2087C23.7825 11.2695 23.8828 11.3607 23.9497 11.4823C24.0166 11.6039 24.05 11.7315 24.05 11.8653V20.6563C24.05 20.936 23.9314 21.1488 23.6943 21.2947C23.4572 21.4406 23.211 21.4467 22.9557 21.3129C22.5058 21.0697 22.0346 20.8813 21.5422 20.7475C21.0497 20.6138 20.5482 20.5469 20.0375 20.5469C19.308 20.5469 18.6027 20.6746 17.9218 20.9299C17.2409 21.1852 16.6086 21.5439 16.025 22.006Z"
                fill="url(#paint1_linear_11575_8504)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_11575_8504"
                    x1="6.18324"
                    y1="2.91051"
                    x2="23.6378"
                    y2="25.8196"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF1B79" />
                    <stop offset="0.432292" stopColor="#FF4E60" />
                    <stop offset="0.994792" stopColor="#2D66E8" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_11575_8504"
                    x1="16.026"
                    y1="5.75258"
                    x2="11.3169"
                    y2="20.8337"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF1B79" />
                    <stop offset="0.432292" stopColor="#FF4E60" />
                    <stop offset="0.994792" stopColor="#2D66E8" />
                </linearGradient>
            </defs>
        </SvgIcon>
    );
}
